<template>
  <div>
    <email-log v-if="allMessages" @switch="allMessages = $event" />
    <email-customers v-else @switch="allMessages = $event" />
  </div>
</template>

<script setup lang="ts">
// Email tab of the Messages page: by customer by default; the Every message filter
// toggle swaps in the per-message log, and switching it off comes back here.
import { ref } from 'vue'
import EmailCustomers from './EmailCustomers.vue'
import EmailLog from './EmailLog.vue'

const allMessages = ref(false)
</script>
